






































exports.default =
  components:
    listItem: require('./list_item.vue')

  props: ['options', 'list_item_options']

  data: ->
    custom_fields: []
    selected_custom_field: {}
    loading: false

  methods:
    loadCustomFields: ->
      filters = @options?.filters || {}
      @custom_fields = @defaultFields()
      @loading = true
      new CustomFieldsResource().index(@loadCustomFieldsSuccess, null, params: { q: filters })

    loadCustomFieldsSuccess: (data) ->
      @loading = false
      @custom_fields = @custom_fields.concat(data.custom_fields)

    openDestroyConfirmationModal: (custom_field) ->
      @selected_custom_field = custom_field
      EventsBus.$emit 'confirm-modal-show', id: 'confirm-destroy-custom-field'

    destroyCustomField: ->
      Loader.on()
      new CustomFieldsResource().destroy(@successDestroyCustomField, @unknownError, id: @selected_custom_field.id)

    successDestroyCustomField: ->
      Loader.off()
      @custom_fields.remove(@selected_custom_field.id)
      alertify.success('Campo personalizado excluído com sucesso')

    customFieldUpdated: (custom_field) ->
      @custom_fields.replaceById(custom_field)

    addCustomField: (custom_field) ->
      @custom_fields.push(custom_field)

    edit: (custom_field) ->
      @$emit('edit', custom_field)

    defaultFields: ->
      [
        { field: 'Nome', kind: 'input', editabled: false }
        { field: 'Sobrenome', kind: 'input', editabled: false }
        { field: 'E-mail', kind: 'email', editabled: false }
        { field: 'Empresa', kind: 'input', editabled: false }
        { field: 'Telefone', kind: 'telephone', editabled: false }
        { field: 'Celular', kind: 'telephone', editabled: false }
      ]

  created: ->
    @loadCustomFields()



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/custom_fields/list.vue